<template>
  <v-dialog v-model="show" width="500">
    <v-card>
      <v-card-title>
        <span class="headline">物流社内品番明細</span>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="save()" class="ml-2">{{ $t('app.buttons.save') }}</v-btn>
        <v-btn @click="show = false" class="ml-2">{{
          $t('app.buttons.back')
        }}</v-btn>
      </v-card-actions>
      <v-container fluid>
        <v-data-table
          :headers="headers"
          :items="packages"
          :rows-per-page-items="[10, 50]"
          class="inline-edit"
          item-key="id"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.skuCode }}</td>
            <td>{{ props.item.totalQty }}</td>
            <td>
              <v-text-field
                placeholder="物流社内品番"
                v-model="props.item.logisticsSku"
              ></v-text-field>
            </td>
          </template>
        </v-data-table>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data: () => ({
    show: false,
    count: 0,
    packages: [],
    headers: [
      { text: '社内品番', sortable: false },
      { text: '数量', sortable: false },
      { text: '物流社内品番', sortable: false },
    ],
  }),
  methods: {
    save() {
      this.show = false
      this.$http
        .put(`packings/update-logistics-sku`, this.packages)
        .then(() => {
          this.$message('', 'SUCCESS')
        })
    },
    popup(pkgs) {
      this.show = true
      this.packages = pkgs.filter((pkg) => pkg.showLogisticsSku)
    },
  },
}
</script>